import { getDynamicSemanticToken } from '../../../DesignSystem';
export function getThemeToken(theme) {
    const semantic = getDynamicSemanticToken(theme);
    return {
        thumb: {
            background: {
                default: semantic.activeMode === 'light'
                    ? semantic.fill.global.dark.transparent
                    : semantic.fill.global.light.transparent,
                active: semantic.activeMode === 'light'
                    ? semantic.fill.global.strong.dark.transparent
                    : semantic.fill.global.strong.light.transparent,
            },
            width: {
                default: 4,
                hover: 8,
            },
        },
        track: {
            background: semantic.activeMode === 'light'
                ? semantic.fill.global.subtle.dark.transparent
                : semantic.fill.global.subtle.light.transparent,
            width: 16,
            border: semantic.border.subtle.neutral,
        },
    };
}
